import { dateFunc } from "@/components/Functions/dateFunc";
import { ClaimData } from "@/features/creditor/claimsTab/Constant/claimTabType";
import { Link } from "react-router-dom";

export const caseRenderers = {
  claimCellRenderer: function (param: {
    colDef: any;
    data: {
      claimId: any;
      claimReferenceId: any;
    };
  }) {
    const {
      colDef: {
        headercomponentParams: { caseId, creditorId },
      },
    } = param;
    let prefix = creditorId
      ? `/case/${caseId}/creditor/${creditorId}`
      : `/case/${caseId}`;
    return (
      <Link
        to={`${prefix}/claim/${param.data.claimId}`}
        state={{ from: param.data.claimId }}
      >
        <span className="text-bold-underline">
          {" "}
          {param.data.claimReferenceId}
        </span>
      </Link>
    );
  },
  creditorNameCellRenderer: function (param: any) {
    return param.data.creditorName !== "" ? (
      <Link
        to={`/case/${param.data.caseId}/creditor/${param.data.creditorId}`}
        style={{ fontWeight: "200" }}
        state={{ from: param.data.claimId }}
      >
        <span className="text-bold-underline">{param.data.creditorName}</span>
      </Link>
    ) : (
      <>-</>
    );
  },
  debtorNameCellRenderer: function (param: any) {
    return param.data.debtorName !== "" ? (
      <Link
        to={`/case/${param.data.caseId}/debtor/edit/${param.data.debtorId}`}
        style={{ fontWeight: "200" }}
      >
        <span className="text-bold-underline">{param.data.debtorName}</span>
      </Link>
    ) : (
      <>-</>
    );
  },
  assigneeNameCellRenderer: function (param: any) {
    return param.data.assigneeName !== "" ? (
      <Link
        to={`/case/${param.data.caseId}/creditor/${param.data.assigneeId}`}
        style={{ fontWeight: "200" }}
        state={{ from: param.data.claimId }}
      >
        <span className="text-bold-underline">{param.data.assigneeName}</span>
      </Link>
    ) : (
      <>-</>
    );
  },

  lastUpdatedRenderer: function (param: ClaimData) {
    return <>{dateFunc(param.data.updatedOn).formattedDateOnly}</>;
  },
};
